<template>
    <div class="o-page__content u-pt-small">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-xl-12">
                    <h1 class="u-h3">Aspects</h1>
                    <div class="custom_toolbar">
                        <input type="text" placeholder="Search..." class="c-input" v-model="params.q" v-on:keyup="search">
                        <el-button style="margin-left: 20px;" type="success" round icon="el-icon-plus" @click="createNew">Create New</el-button>
                    </div>
                </div>
            </div>
            <div class="row u-mt-medium">
                <div class="col-12">
                    <vue-good-table v-loading="loading"
                        mode="remote"
                        :columns="columns"
                        :rows="rows"
                        :totalRows="totalRecords"
                        @on-page-change="onPageChange"
                        :select-options="{ 
                            enabled: true,
                            selectOnCheckboxOnly: true,
                            disableSelectInfo: true
                        }"
                        :pagination-options="{
                            enabled: true
                        }">

                        <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field == 'stars'">
                                <span v-if="props.row.stars" v-for="item in JSON.parse(props.row.stars)" :key="item.qty">
                                    <el-rate
                                        :value="item.qty"
                                        disabled
                                        show-score
                                        text-color="#ff9900"
                                        :score-template="item.description.length>=100?`${item.description.substring(0, 100)}...`:item.description">
                                    </el-rate>
                                </span>
                            </span>
                            <span v-else-if="props.column.field == 'action'">
                                <el-button size="mini" icon="el-icon-edit" circle @click="editAspect(props.row.originalIndex)"></el-button>
                                <el-button size="mini" type="danger" icon="el-icon-delete" @click="showAlertDelete(props.row.id)" circle></el-button>
                            </span>
                            <!-- <span v-else-if="props.column.field == 'status'">
                                <el-switch active-color="#13ce66" inactive-color="#edf1f7" :value="props.row.status==1 ? true : false" @change="switchChanged(props.row.originalIndex)"></el-switch>
                            </span> -->
                            <span v-else>
                                {{props.formattedRow[props.column.field]}}
                            </span>
                        </template>

                    </vue-good-table>
                </div>
            </div>
        </div>

        <el-dialog title="Edit Aspect" :visible.sync="dialogFormVisible" width="40%">
            {{formErrorText}}
            <el-form :model="form">
                <el-form-item label="Name">
                    <el-input v-model="form.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="Stars">
                    <div v-for="(item, id) in form.stars" :key="id">
                        <div v-if="id==0" style="margin: 40px 0 0;"></div>
                        <div v-else style="margin: 10px 0 0;"></div>
                        <el-rate disabled show-score text-color="#ff9900" v-model="item.qty"></el-rate>
                        <el-input type="textarea" autosize v-model="item.description" autocomplete="off"></el-input>
                    </div>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">Cancel</el-button>
                <el-button type="primary" @click="saveAspect()" :loading="loading2">Confirm</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table';
    import api from '@/api/aspects'
    import { mapActions } from 'vuex';

    export default {
        name: 'aspects',
        components: {
            'vue-good-table':VueGoodTable
        },
        data() {
            return {
                inputTagVisible: false,
                inputTagValue: '',
                dialogFormVisible: false,
                form: {
                    id: '',
                    name: '',
                    stars: '',
                    rules: ''
                },
                rulesList: [
                    {id: 1, name: 'Pimpinan', checked: false},
                    {id: 2, name: 'Customer Service', checked: false},
                    {id: 3, name: 'Teller', checked: false},
                    {id: 4, name: 'Satpam', checked: false},
                    {id: 5, name: 'Premise', checked: false},
                    {id: 6, name: 'Telepon Cabang', checked: false}
                ],
                columns: [
                    {
                        label: 'Name',
                        field: 'name'
                    },
                    {
                        label: 'Stars',
                        field: 'stars'
                    },
                    {
                        label: 'Action',
                        field: 'action',
                        thClass: 'u-text-center',
                        tdClass: 'u-text-center',
                        width: '100px'
                    }
                ],
                rows: [],
                totalRecords: 0,
                page: 1,
                params: {
                    q: ''
                },
                loading: false,
                loading2: false,
                formErrorText: '',
                formType: 'edit'
            }
        },
        created () {
            this.fetch();
        },
        methods: {
            ...mapActions([
                'logout'
            ]),
            fetch() {
                this.loading = true
                var self = this
                api.get(this.page, this.params.q)
                .then(function (response) {
                    self.rows = response.data.data
                    self.totalRecords = response.data.meta.totalRecords
                    self.loading = false
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            onPageChange(params) {
                console.log(params)
                this.page = params.currentPage
                this.fetch();
            },
            myChangeEvent4(val){
                console.log(val);
                this.params.position = val
                this.fetch();
            },
            search() {
                this.fetch();
            },
            switchChanged(id){
                console.log(id);
                console.log(this.rows[id])
                var self = this
                api.update(this.rows[id].id, {status: !this.rows[id].status})
                .then(function (response) {
                    self.fetch()
                    self.$message({
                        type: 'success',
                        message: response.data.message
                    });
                })
                .catch(function (error) {
                    self.loading2 = false
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            editAspect(id){
                this.formType = 'edit'
                // console.log(id)
                this.form = {
                    id: this.rows[id].id,
                    name: this.rows[id].name,
                    stars: this.rows[id].stars ? JSON.parse(this.rows[id].stars) : []
                }
                // console.log(rulesList)
                this.dialogFormVisible = true
            },
            handleCloseTag(tag) {
                this.form.stars.splice( this.form.stars.indexOf(tag) , 1)
            },
            showInput() {
                this.inputTagVisible = true;
                this.$nextTick(_ => {
                    this.$refs.saveTagInput.$refs.input.focus();
                });
            },
            handleInputConfirm() {
                let inputTagValue = this.inputTagValue;
                if (inputTagValue) {
                    this.form.stars.push(inputTagValue);
                }
                this.inputTagVisible = false;
                this.inputTagValue = '';
            },
            saveAspect(){
                if(this.formType == 'add'){
                    this.addAspect()
                } else {
                    var params = {
                        name: this.form.name,
                        stars: JSON.stringify(this.form.stars)
                    }
                    this.loading2 = true
                    var self = this
                    api.update(this.form.id, params)
                    .then(function (response) {
                        self.loading2 = false
                        self.dialogFormVisible = false
                        self.fetch()
                        self.$message({
                            type: 'success',
                            message: response.data.message
                        });
                    })
                    .catch(function (error) {
                        self.loading2 = false
                        console.log(error);
                        self.formErrorText = error.response.data.message
                        if(error.response.status == 403){
                            self.logout()
                        }
                    })
                }
            },
            showAlertDelete(id){
                this.$confirm('This will permanently delete the data. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.deleteAspect(id)
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },
            deleteAspect(id){
                var self = this
                api.delete(id)
                .then(function (response) {
                    self.$message({
                        type: 'success',
                        message: 'Delete completed'
                    });
                    self.fetch()
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            createNew() {
                this.formType = 'add'
                this.form = {
                    id: '',
                    name: '',
                    stars: [
                        {
                            qty: 1,
                            description: ''
                        },
                        {
                            qty: 2,
                            description: ''
                        },
                        {
                            qty: 3,
                            description: ''
                        },
                        {
                            qty: 4,
                            description: ''
                        },
                        {
                            qty: 5,
                            description: ''
                        }
                    ]
                }
                this.dialogFormVisible = true
            },
            addAspect() {
                var params = {
                    name: this.form.name,
                    stars: JSON.stringify(this.form.stars)
                }
                this.loading2 = true
                var self = this
                api.create(params)
                .then(function (response) {
                    self.loading2 = false
                    self.dialogFormVisible = false
                    self.fetch()
                    self.$message({
                        type: 'success',
                        message: response.data.message
                    });
                })
                .catch(function (error) {
                    self.loading2 = false
                    console.log(error);
                    self.formErrorText = error.response.data.message
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.custom_toolbar {
    display: flex;
    div {
        margin-right: 10px;
    }
}
.el-dialog-body {
    padding: 10px 20px !important;
}
.el-form-item {
    margin-bottom: 10px !important;
}
</style>